import type { RouterConfig } from '@nuxt/schema';
export default <RouterConfig>{
	scrollBehavior: (to, from, savedPosition) => {

		const diamondDetailPagePaths = ['loose-detail', 'cyo-diamond-detail-ring', 'cyo-diamond-detail-pendant', 'cyo-diamond-detail-earring', 'cyo-complete-ring']
		const TransitionTime = 0;
		const isListPageWithoutStartWith = (from: any, to: any) => {
			if (from.name?.includes('-list-') && to.name?.includes('-list-') && !to.params?.start_with) {
				return true;
			}
			return false;
		};

		// Disable scroll when ShopTheLookId or any UTM parameter is present

		if((to?.hash ?? '').toLowerCase().startsWith('#space_from_top') && !savedPosition){
			return null;
		}

		if (
			'ShopTheLookId' in (to?.query ?? {}) ||
			Object.keys(to?.query ?? {}).some((k) => k.toLowerCase().startsWith('utm_'))
		) {
			return null;
		}
		
		// Disable scroll for list page navigation without start_with param
		if (isListPageWithoutStartWith(from, to)) {
			// console.log(' \u{1F680} isListPageWithoutStartWith', from, to)
			return null;
		}

		// if transition in between diamond detail page, change of metal or shape, don't scroll to top
		if ( from.name === to.name){
			// console.log(' \u{1F680} from.name === to.name', from, to)
			return null
		}

		// first page load 
		if( !from?.name){
			if( savedPosition ){
                return { left: 0, top: 0, behavior: 'instant' }
            }
			// console.log(' \u{1F680} !from?.name', from, to)
			return null
		}

		// Restore saved position (back/forward navigation)
		if (savedPosition) {
			// HARDCODED from is absent and savedPosition left is 0,it means it is a new page
			console.log(' \u{1F680} savedPosition', savedPosition)
			// return new Promise((resolve) => {
			// 	setTimeout(() => {
			// 		resolve({ ...savedPosition, behavior: 'instant' });
			// 	}, TransitionTime);
			// });

			return new Promise((resolve) => {
				const nuxtApp = useNuxtApp()
				let done = false
				
				const finish = () => {
				  if (done) return
				  done = true
				  resolve( { ...savedPosition, behavior: 'instant' } )
				}
				// console.log(' \u{1F680} nuxtApp.hooks.hookOnce')
				nuxtApp.hooks.hookOnce('page:transition:finish', finish)
				setTimeout(finish, 8000) // shorter fallback
			})
		}
		
		// console.log(' \u{1F680} return new Promise', savedPosition)
		return new Promise((resolve) => {
			const nuxtApp = useNuxtApp()
			let done = false
			
			const finish = () => {
			  if (done) return
			  done = true
			  resolve(savedPosition || { left: 0, top: 0, behavior: 'instant' })
			}
			// console.log(' \u{1F680} nuxtApp.hooks.hookOnce')
			nuxtApp.hooks.hookOnce('page:transition:finish', finish)
			setTimeout(finish, 8000) // shorter fallback
		})
	}
};
